import classNames from "classnames";
import React from "react";

interface IProps {
  className?: string | classNames.ArgumentArray;
  children: React.ReactNode;
}

function MenuList({ children, className }: IProps) {
  return <ul className={classNames("flex", className)}>{children}</ul>;
}

export default MenuList;
